import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
/**
 * Quick Button
 */
const ListButtonTitle = ({ boxStyle, item, viewType,  }) => {
  const { items, id, type } = item;

  return (
    <>
      <div className="_list_button_description_div" style={boxStyle} >
        {items !== undefined &&
          items.map((tempItem, idx) => {
            return (
            <div className="_list_button_description_area" key={`${id}_${idx}_area`}>
              <h2 className="_h2_title">
                {ReactHtmlParser(tempItem?.text?.desc || '')}
              </h2>
            </div>
          );
        })}
      </div>
    </>
  );
};
ListButtonTitle.propTypes = {
  boxStyle: PropTypes.object,
  item: PropTypes.object,
  viewType: PropTypes.string,
};
ListButtonTitle.defaultProps = {
  boxStyle: {},
  item: {},
  viewType: 'advise', // advise, simulator, knowledge
};

export default ListButtonTitle;

